export default {
  parseDOM: [{ tag: 's' }],
  toDOM() {
    return ['s', 0];
  },
};
